<script setup>
// /nexus: atalho (e o endereço de antes do menu com seções). Leva para a
// primeira seção que a empresa tem; sem nenhuma, explica.
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { secoesLiberadas, useRecursos } from './recursos';
import messages from './i18n';

const { t } = useI18n({ messages });
const router = useRouter();
const { accountId } = useAccount();
const recursos = useRecursos();

watch(
  recursos,
  valor => {
    const primeira = secoesLiberadas(valor)[0];
    if (primeira) {
      router.replace({
        name: primeira.rota,
        params: { accountId: accountId.value },
      });
    }
  },
  { immediate: true }
);
</script>

<template>
  <section class="flex justify-center w-full h-full px-6 py-10 bg-n-surface-1">
    <Spinner v-if="recursos === null" />
    <p
      v-else
      class="self-start max-w-5xl p-4 text-sm rounded-xl bg-n-alpha-2 text-n-slate-11"
    >
      {{ t('NEUXS_NEXUS.SEM_SGP') }}
    </p>
  </section>
</template>
